import React, { useEffect } from 'react';
import { XCircleIcon, XIcon } from '@heroicons/react/solid';

function Toast({ isOpen, onClose, message, type = 'error' }) {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // Auto-dismiss after 5 seconds

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const styles = {
    error: {
      bg: 'bg-red-600',
      text: 'text-white',
      icon: 'text-red-200',
      hoverBg: 'hover:bg-red-700',
      ringColor: 'focus:ring-red-400',
      ringOffset: 'focus:ring-offset-red-600',
    },
    success: {
      bg: 'bg-green-600',
      text: 'text-white',
      icon: 'text-green-200',
      hoverBg: 'hover:bg-green-700',
      ringColor: 'focus:ring-green-400',
      ringOffset: 'focus:ring-offset-green-600',
    },
  };

  const currentStyle = styles[type] || styles.error;

  return (
    <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-md px-4">
      <div className={`rounded-md ${currentStyle.bg} p-4 shadow-2xl border border-gray-900 border-opacity-10`}>
        <div className="flex">
          <div className="flex-shrink-0">
            <XCircleIcon
              aria-hidden="true"
              className={`h-5 w-5 ${currentStyle.icon}`}
            />
          </div>
          <div className="ml-3">
            <p className={`text-sm font-medium ${currentStyle.text}`}>
              {message}
            </p>
          </div>
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                type="button"
                onClick={onClose}
                className={`inline-flex rounded-md ${currentStyle.bg} p-1.5 ${currentStyle.icon} ${currentStyle.hoverBg} focus:ring-2 ${currentStyle.ringColor} focus:ring-offset-2 ${currentStyle.ringOffset} focus:outline-none`}
              >
                <span className="sr-only">Dismiss</span>
                <XIcon aria-hidden="true" className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Toast;